import http from "../../index";
import type { Admin, LoginData, LoginResponse } from "./types";
import { decryptWithAES, encryptWithAES } from "../../../utils/parse";

namespace auth {
  const userKey = "app.user";
  const tokenKey = "app.token";
  const orgKey = "org.id";

  export const saveToken = (token: string) => {
    localStorage.setItem(tokenKey, token);
  };

  export const rememberUser = (values: LoginData) => {
    if (values.device_id) {
      localStorage.setItem(userKey, encryptWithAES(JSON.stringify(values)));
    } else {
      localStorage.removeItem(userKey);
    }
  };

  export const getRememberUser = () => {
    const userData = localStorage.getItem(userKey);
    if (userData) {
      const _userData = JSON.parse(decryptWithAES(userData)) as LoginData;
      return _userData;
    }
    return undefined;
  };

  export const remToken = () => {
    localStorage.removeItem(tokenKey);
  };

  export const hasToken = () => !!localStorage.getItem(tokenKey);

  export const getToken = () => localStorage.getItem(tokenKey);

  export const setOrg = (id: string | undefined) => {
    if (id) localStorage.setItem(orgKey, id);
  };

  export const getOrg = () => localStorage.getItem(orgKey);

  export const info = () =>
    http.get<Admin>("/admin/auth/info", { hasAuth: true });

  export const login = (body: LoginData) =>
    http.post<LoginResponse>("/admin/auth/login", {
      body,
    });
}

export default auth;
